import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4cdbba0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=a4cdbba0&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=a4cdbba0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cdbba0",
  null
  
)

export default component.exports